import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {formatCurrency} from '@/utilities/helpers'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {DashboardConsultantSearchParams} from '../../types'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardConsultantCardEmptyState} from '../dashboard-consultant-hours-card/DashboardConsultantCardEmptyState'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useMemo} from 'react'

export const DashboardEffectiveCostCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardConsultantSearchParams)
    const {isLoading, data} = useGetDashboardConsultants(
        {
            fields: ['costs'],
            ...searchParams
        },
        {enabled: !!searchParams.consultant}
    )

    const hasConsultant = !!searchParams.consultant

    const difference = useMemo(() => {
        return data?.costs ? data.costs.total - data.costs.forfait : 0
    }, [data])

    return (
        <DashboardCard title={t('dashboard:cost_difference')}>
            {!hasConsultant ? (
                <DashboardConsultantCardEmptyState />
            ) : isLoading ? (
                <Flexbox direction="column" gap={4} fullWidth>
                    <Skeleton width="45%" height={28} />
                    <Flexbox direction="column" gap={2}>
                        <Skeleton width="60%" height={16} />
                        <Skeleton width="55%" height={16} />
                    </Flexbox>
                </Flexbox>
            ) : (
                <Flexbox direction="column" gap={4} fullWidth>
                    <Text palette={difference < 0 ? 'danger' : 'success'} shade="500" size="displaySm" weight={700}>
                        {formatCurrency(difference)}
                    </Text>

                    <ul>
                        <li>
                            <Flexbox align="center" gap={1}>
                                <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                    {formatCurrency(data?.costs?.total ?? 0)}
                                </Text>
                                <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                    {t('dashboard:effective_costs')}
                                </Text>
                            </Flexbox>
                        </li>
                        <li>
                            <Flexbox align="center" gap={1}>
                                <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                    {formatCurrency(data?.costs?.forfait ?? 0)}
                                </Text>
                                <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                    {t('dashboard:forfait')}
                                </Text>
                            </Flexbox>
                        </li>
                    </ul>
                </Flexbox>
            )}
        </DashboardCard>
    )
}
